import React from "react";
import {DashboardCard} from "../../designSystem/components/DashboardCard";
import {Typography} from "../../designSystem/components/Typography";
import {surveyQuestions} from "./constant";

interface ApplicationSurveyViewProps {
  surveyResponses: Record<string, string>;
  feedbackDescription: string;
}

export const ApplicationSurveyView = ({
  surveyResponses,
  feedbackDescription
}: ApplicationSurveyViewProps) => (
  <DashboardCard>
    <Typography variant="subtitle">
      滿意度調查結果
    </Typography>
    <div className="space-y-4">
      {surveyQuestions.map(({ id, text }) => (
        <div
          key={id}
          className="flex flex-col"
        >
          <span className="font-medium text-gray-700">
            {text}
          </span>
          <span className="text-gray-600">
            {surveyResponses?.[id] || "未填寫"}
          </span>
        </div>
      ))}

      {feedbackDescription && (
        <div className="flex flex-col">
          <span className="font-medium text-gray-700">
            其他建議事項
          </span>
          <span className="text-gray-600 whitespace-pre-line">
            {feedbackDescription}
          </span>
        </div>
      )}
    </div>
  </DashboardCard>
);
